import { render, staticRenderFns } from "./UserSettings_AvatarUpload.vue?vue&type=template&id=26d40ab4&scoped=true&"
import script from "./UserSettings_AvatarUpload.vue?vue&type=script&lang=js&"
export * from "./UserSettings_AvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings_AvatarUpload.vue?vue&type=style&index=0&id=26d40ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d40ab4",
  null
  
)

export default component.exports